import { t } from "@lingui/core/macro";
import { Button } from "@/components/ui/button.tsx";
import { cn } from "@/lib/utils.ts";
import { PageCenter } from "@/components/PageCenter.tsx";
import { BanknoteX } from "lucide-react";
import { Trans } from "@lingui/react/macro";

interface Props {
  className?: string;
}

export function CommonError({ className }: Props) {
  return (
    <PageCenter>
      <div className={cn("flex flex-col py-12 px-28 items-center justify-center gap-8", className)}>
        <BanknoteX className={"text-destructive"} size={50} />
        <p className={"text-center text-muted-foreground"}>
          <Trans>Something went wrong. We were unable to load the app. Please refresh the page and try again.</Trans>
        </p>
        <Button
          type={"button"}
          className={"cursor-pointer"}
          variant={"secondary"}
          onClick={() => window.location.reload()}
        >{t`Reload page`}</Button>
      </div>
    </PageCenter>
  );
}
